import { useState, useEffect } from 'react';
import { buttonStyle} from '../libs/sharedStyles.js';
import { primaryButtonClasses, secondaryButtonClasses } from '../libs/sharedClassNames.js';
import { useNavigate } from 'react-router-dom';
import { updateUserPassword } from '../libs/fetch.js';
import { useAuthContext } from '../contexts/AuthContext.jsx';

export default function SetPassword() {
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const { setLoading, session, profile, refreshProfile } = useAuthContext();
  const [requiresSetPassword, setRequiresSetPassword] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (!session) {
      setLoading(false);
    } else {
      setRequiresSetPassword(profile?.requires_password_set || false);
    }
  }, [session]);

  const togglePasswordVisibility = () => setShowPassword(!showPassword);

  async function handleUpdatePassword(event) {
    event.preventDefault();

    const { data, error } = await updateUserPassword(password);
    if (error) {
      setErrorMessage(error.message)
    } else {
      await refreshProfile();
      navigate('/');
    }
  };

  return (
    <>
      <div className="mx-auto max-w-7xl">
        <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-12">
          {requiresSetPassword && (
            <div className="sm:mx-auto sm:w-full sm:max-w-sm">
              <h2 className="text-2xl font-bold leading-tight tracking-tight lg:pb-3">Welcome to Muffin Data!</h2>
              <div className="lg:pb-8 text-sm leading-6 text-gray-600">To get started, please set your password below.</div>
            </div>
          )}

          <form onSubmit={handleUpdatePassword}>
            <div className="space-y-12">
              <div className="border-b border-gray-900/10 pb-12">
                {requiresSetPassword ?
                <h2 className="text-xl font-bold leading-tight tracking-tight lg:pb-3">Set Password</h2>
                :
                <h2 className="text-xl font-bold leading-tight tracking-tight lg:pb-3">Update Password</h2>
                }
                <p className="text-sm leading-6 text-gray-600">
                  8 characters minimum and can't be a password you have used before.
                </p>

                <div className="mt-2 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                  <div className="sm:col-span-4">
                    <label htmlFor="password" className="block text-sm font-medium leading-6 text-gray-900">
                      New Password
                    </label>
                    <div className="w-[30rem]">
                      <input
                        id="password"
                        name="password"
                        type={showPassword ? "text" : "password"}
                        required
                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-700 sm:text-sm sm:leading-6 px-3 py-2"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        minLength="8"
                      />
                      <fieldset>
                        <legend className="sr-only">Show Password</legend>
                        <div className="space-y-5 mt-2">
                          <div className="relative flex items-start">
                            <div className="flex h-6 items-center">
                              <input
                                id="showPassword"
                                name="showPassword"
                                type="checkbox"
                                className="h-4 w-4 rounded border-gray-100 accent-primaryBrandColor focus:ring-brandNeutral"
                                onChange={togglePasswordVisibility}
                                checked={showPassword}
                              />
                            </div>
                            <div className="ml-3 text-sm leading-6">
                              <label htmlFor="showPassword" className="font-medium text-gray-900">
                                Show Password
                              </label>
                            </div>
                          </div>
                        </div>
                      </fieldset>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-3">
              {errorMessage && (
                <div className="text-sm font-medium text-red-600">
                  {errorMessage}
                </div>
              )}
            </div>
            <div className="mt-6 flex items-center justify-start">

              <button
                type="submit"
                style={buttonStyle}
                className={primaryButtonClasses}
              >
                Set Password
              </button>
              {!requiresSetPassword && (
                <button type="button" style={buttonStyle} className={secondaryButtonClasses} onClick={() => navigate('/home')}>
                  Cancel
                </button>
              )}
            </div>
          </form>
        </div>
      </div>
    </>
  )
};
